<div class="my-3 my-md-5">
    <div class="container-fluid">
        <h1 class="page-title">Scan Booked List</h1>
    </div>

    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="row mb-2 mt-2">
                    <div class="col-sm-2 mt-2"><input class="form-control" [(ngModel)]="search" type="text" placeholder="Search" /></div>
                    <div class="col-sm-2 mt-2" *ngIf="myrole=='1' || myrole=='3'  || myrole=='4' || myrole=='8'">
                        <mat-select  placeholder="Bds" [(ngModel)]="bd" (click)="setSearchValue('lead_owner')" multiple>
                            <input class="mySearchInput"
                            #ownerSearch focused="'true'" type="text"
                            (keyup)="searchOnSelect($event.target.value, 'lead_owner')"
                            (keydown)="$event.stopPropagation()" autocomplete="off"
                            placeholder="Search"
                            id="ownerSearch">
                            <mat-option value="{{bd.id}}" *ngFor="let bd of bds">{{bd.name}}</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-2 mt-2" *ngIf="myrole=='1' || myrole=='3'  || myrole=='4' || myrole=='8'">
                      <mat-select  placeholder="Scanpro" [(ngModel)]="scan_pro_id" (click)="setSearchValue('scan_pro_id')">
                          <input class="mySearchInput"
                          #scan_pro_idSearch focused="'true'" type="text"
                          (keyup)="searchOnSelect($event.target.value, 'scan_pro_id')"
                          (keydown)="$event.stopPropagation()" autocomplete="off"
                          placeholder="Search"
                          id="scan_pro_idSearch">
                          <mat-option value="NA">Not Assigned</mat-option>
                          <mat-option value="{{scan_pro_id.id}}" *ngFor="let scan_pro_id of scanProUser">{{scan_pro_id.name}}</mat-option>
                      </mat-select>
                    </div>
                    <div class="col-sm-2 mt-2">
                        <mat-select  placeholder="Circle" [(ngModel)]="circle" multiple>
                            <mat-option value="{{cir.id}}" *ngFor="let cir of circles">{{cir.name}}</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-2 mt-2">
                        <mat-select  placeholder="Payment Status"  [(ngModel)]="payment_status">
                            <mat-option >All</mat-option>
                            <mat-option value="1">Yes</mat-option>
                            <mat-option value="2">No</mat-option>
                            
                        </mat-select>
                    </div>
                    <div class="col-sm-2 mt-2">
                        <mat-select  placeholder="Scan Status" [(ngModel)]="scan_status">
                            <mat-option >All</mat-option>
                            <mat-option value="1">Yes</mat-option>
                            <mat-option value="2">No</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-2 mt-2">
                      <mat-select  placeholder="Appointment Type"  [(ngModel)]="appointment_type">
                        <mat-option >All</mat-option>
                        <mat-option value="1">New Scan</mat-option>
                        <mat-option value="2">Re-Scan</mat-option>
                        <mat-option value="3">Trust Align</mat-option>
                          
                      </mat-select>
                    </div>
                    <div class="col-sm-2 mt-2">
                      <mat-select  placeholder="MdSpoc" [(ngModel)]="mdspok" (click)="setSearchValue('mdspok')">
                          <input class="mySearchInput"
                          #mdspokSearch focused="'true'" type="text"
                          (keyup)="searchOnSelect($event.target.value, 'mdspok')"
                          (keydown)="$event.stopPropagation()" autocomplete="off"
                          placeholder="Search"
                          id="mdspokSearch">
                          <mat-option value="{{mdspok.id}}" *ngFor="let mdspok of mdSpokData">{{mdspok.name}}</mat-option>
                      </mat-select>
                    </div>
                    <div class="col-sm-2 mt-2" *ngIf="myrole=='1' || (myrole=='3' && userId == '411') || userId == '431' || userId=='125' || myrole=='21'">
                      <mat-select  placeholder="Dental MdSpoc" [(ngModel)]="dental_mdspok" (click)="setSearchValue('dental_mdspok')">
                          <input class="mySearchInput"
                          #dental_mdspokSearch focused="'true'" type="text"
                          (keyup)="searchOnSelect($event.target.value, 'dental_mdspok')"
                          (keydown)="$event.stopPropagation()" autocomplete="off"
                          placeholder="Search"
                          id="dental_mdspokSearch">
                          <mat-option value="NA">Not Assigned</mat-option>
                          <mat-option value="{{dental_mdspok.id}}" *ngFor="let dental_mdspok of dentalSpocRole">{{dental_mdspok.name}}</mat-option>
                      </mat-select>
                    </div>

                    <div class="col-sm-2 mt-2" *ngIf="myrole=='1' || (myrole=='3' && userId == '411') || userId == '431' || userId=='125' || myrole=='21'">
                      <mat-select placeholder="Spoc Remarks Status" [(ngModel)]="dental_spoc_status" (click)="setSearchValue('dental_spoc_status')">
                        <input class="mySearchInput"
                        #allStatusSearch focused="'true'" type="text"
                        (keyup)="searchOnSelect($event.target.value, 'dental_spoc_status')"
                        (keydown)="$event.stopPropagation()" autocomplete="off"
                        placeholder="Search"
                        id="allStatusSearch">
                        <mat-option [value]="data.id" *ngFor="let data of allSpocStatus">{{data.name}}</mat-option>
                      </mat-select>
                    </div>

                    <div class="col-sm-2 mt-2">
                      <mat-select  placeholder="Visit Type" [(ngModel)]="visit_type">
                          <mat-option value="1">Home</mat-option>
                          <mat-option value="2">Clinic</mat-option>
                          <mat-option value="3">Glamyo</mat-option>
                      </mat-select>
                  </div>
                    

                    <div class="col-sm-2 mt-2">
                        <mat-form-field appearance="fill">
                            <mat-label>Appointment Date Filter</mat-label>
                            <mat-date-range-input [rangePicker]="picker">
                                <input matStartDate #dateRangeStart placeholder="Start date">
                                <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                        </mat-form-field>
                        <mat-icon (click)="clearDate()">clear</mat-icon>
                    </div>
                    <div class="col-sm-2 mt-2">
                        <mat-form-field appearance="fill">
                            <mat-label>Payment Date Filter</mat-label>
                            <mat-date-range-input [rangePicker]="paymentpicker">
                                <input matStartDate #paymentdateRangeStart placeholder="Start date">
                                <input matEndDate #paymentdateRangeEnd placeholder="End date" (dateChange)="paymentdateRangeChange(paymentdateRangeStart, paymentdateRangeEnd)">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matSuffix [for]="paymentpicker"></mat-datepicker-toggle>
                            <mat-date-range-picker #paymentpicker></mat-date-range-picker>
                        </mat-form-field>
                        <mat-icon (click)="paymentclearDate()">clear</mat-icon>
                    </div>
                    <div class="col-sm-2 mt-2" *ngIf="myrole=='1' || (myrole=='3' && userId == '411') || userId == '431' || userId=='125' || myrole=='21'">
                      <mat-form-field appearance="fill">
                          <mat-label>Spoc Followup Date Filter</mat-label>
                          <mat-date-range-input [rangePicker]="spocfollowuppicker">
                              <input matStartDate #spocFollowupdateRangeStart placeholder="Start date">
                              <input matEndDate #spocFollowupdateRangeEnd placeholder="End date" (dateChange)="spocFOllowUpdateRangeChange(spocFollowupdateRangeStart, spocFollowupdateRangeEnd)">
                          </mat-date-range-input>
                          <mat-datepicker-toggle matSuffix [for]="spocfollowuppicker"></mat-datepicker-toggle>
                          <mat-date-range-picker #spocfollowuppicker></mat-date-range-picker>
                      </mat-form-field>
                      <mat-icon (click)="spocfollowupclearDate()">clear</mat-icon>
                  </div>
                  <div class="col-sm-4 mt-2">
                        <button type="button" class="btn btn-primary mb-4" (click)="loadScanBooks(0,perpage)"> <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                        <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i class="fa fa-sync"></i> Reset Filters</button>
                  </div>
                  </div>
                </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3">
                    <button type="button" class="btn btn-success" [disabled]="loading" (click)="loadScanBooks(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Refresh List</button>

                    <button type="button" *ngIf="myrole=='1' || myrole=='2' || myrole=='3'|| myrole=='4' || myrole=='9' || myrole=='18'" class="btn btn-success ml-2" [disabled]="loading" (click)="exportScanList()"><i class="fa fa-file-excel"></i> Export List</button>

                  <!-- <span *ngIf="userId=='167'">
                  <button type="button" class="ml-2 btn btn-success text-white" [disabled]="loading" (click)="showAssignedtoSpokModal()"><i class="fa fa-upload"></i> Bulk Assigned to Dental Spok</button>
                  </span> -->

                </div>
                <div class="col-sm-6"><mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator></div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Status</th>
                        <th>Scan Status</th>
                        <th>Scanpro Assignment</th>
                        <th>Appointment Id</th>
                        <th>Glamyo Partner Id</th>
                        <th>Glamyo Appointment Id</th>
                        <th *ngIf="myrole!='2'">Lead Source</th>
                        <th class="tablefixcoloumn">Patient Name</th>
                        <th>Patient Age</th>
                        <th>Gender</th>
                        <th *ngIf="myrole=='1' || userId == '125' || userId == '431' || userId == '548' || userId == '172' || userId == '63' || userId == '525' || userId == '346' || userId == '576' || userId == '490' || userId == '619' || userId == '388' || userId == '727'">Patient Mobile</th>
                        <th>Patient Email</th>
                        <th *ngIf="myrole=='1' || myrole=='4'|| myrole=='21' || myrole=='11'">Kaleyra C2C</th>
                        <th *ngIf="myrole=='1' || myrole=='4' || myrole=='21' || myrole=='11' || userId == '125' || userId == '431' || userId == '490'">Call Details</th>
                        <th>Circle</th>
                        <th>Lead Owner</th>
                        <th>Treatment</th>
                        <th>Machine</th>                                                                  
                        <th>Appointment Type</th>
                        <th>Lead Date</th>
                        <th>Appointment Date</th>
                        <th>Timeslot</th>
                        <th>Payment Date</th>
                        <th>Visit Type</th>
                        <th>Visit Address</th>
                        <th>Hospital Name</th>
                        <th>Package Price</th>
                        <th>Total Amount</th>
                        <th>Received Amount</th>
                        <th>GST Amount</th>
                        <th>Net Amount</th>
                        <th>Plan Sent At</th>
                        <th>Plan Approved</th>
                        <th>Approval Received Date</th>
                        <th>RCA</th>
                        <th>Sub RCA</th>
                        <th>Campaign Name</th>
                        <th>Keywords</th>
                        <th>AD Group Id</th>
                        <th>Match Type</th>
                        <th>Form Lead Source</th>
                        <th>MD Spoc</th>
                        <th *ngIf="myrole=='1' || (myrole=='3' && userId == '411') || userId=='125' || userId == '431' || userId == '548'">ASSIGNED TO Dental Spoc</th>
                        <th *ngIf="myrole=='1' || (myrole=='3' && userId == '411') || userId=='125' || userId == '431' || userId == '548'">Dental Spoc Remark Status</th>
                        <th *ngIf="myrole=='1' || (myrole=='3' && userId == '411') || userId=='125' || userId == '431' || userId == '548'">Dental Spoc Remark Sub Status</th>
                        <th *ngIf="myrole=='1' || (myrole=='3' && userId == '411') || userId=='125' || userId == '431' || myrole=='21' || userId == '548'">Spoc Followup Date</th>
                        <th *ngIf="myrole=='1' || (myrole=='3' && userId == '411') || userId=='125' || userId == '431' || userId == '548'">Dental MD Spoc</th>
                        <th *ngIf="myrole!='15' && myrole!='6' && myrole!='19' && myrole!='7'">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let opd of scanList;let index = index;">
                        <td >{{(pageIndex*perpage)+index+1}}</td>
                        
                        <td>
                            <span class='p-2 badge' [ngClass]="{'badge-info':opd.status==0}" *ngIf="opd.status==0"><i class="fa fa-dot-circle"></i> Active</span>
                            <span class='p-2 badge' [ngClass]="{'badge-success':opd.status==1}" *ngIf="opd.status==1"><i class="fa fa-check"></i> Completed</span>
                            <span class='p-2 badge' [ngClass]="{'badge-danger':opd.status==3}" *ngIf="opd.status==3"><i class="fa fa-times"></i> Cancelled</span>
                        </td>
                        <td>
                            <span class='p-2 badge' [ngClass]="{'badge-success':opd.scan_status==1}" *ngIf="opd.scan_status==1"><i class="fa fa-check"></i> Yes</span>
                            <span class='p-2 badge' [ngClass]="{'badge-danger':opd.scan_status != 1}" *ngIf="opd.scan_status != 1"><i class="fa fa-times"></i> No</span>
                            <span style="margin-top: 5px;" *ngIf="opd.scan_status==1 && (myrole == '1' || myrole == '3' || myrole == '11')" class='p-2 badge badge-primary pointer-cur' (click)="scanBookCaseHistory(opd.id)"><i class="fa fa-pen"></i> &nbsp;Case History</span>
                        </td>
                        <td>
                          <span *ngIf="myrole != '11' && myrole != '21' && myrole != '8' && myrole != '7' && myrole != 24" class='p-2 badge badge-info pointer-cur' (click)="scanproAssignment(opd.id)"> <i class="fa fa-pen"></i> &nbsp;Pro Assignment</span><br>
                          {{opd.scan_pro_user}}
                        </td>
                        <td>{{opd.appointment_id}}</td>
                        <td>{{opd.glamyo_patient_id}}</td>
                        <td>GHDEN{{opd.id}}</td>
                        
                        <td *ngIf="myrole!='2'"><span class='p-2 badge btn-primary'>{{sharedapi.getLeadSource(opd.lead_source)}}</span></td>

                        <td class="tablefixcoloumn">{{opd.lead_name}}</td>
                        <td>{{opd.patient_age}}</td>
                        <td>{{opd.gender}}</td>
                        <td  *ngIf="myrole=='1' || userId == '125' || userId == '431' || userId == '548' || userId == '172' || userId == '63' || userId == '525' || userId == '346' || userId == '576' || userId == '490' || userId == '619' || userId == '388' || userId == '727'">{{opd.mobile}}</td>
                        <td>{{opd.email}}</td>
                        <td *ngIf="myrole=='1' || myrole=='4' || myrole=='21' || myrole=='11'"><span class='p-2 badge btn-success pointer-cur' (click)="click_to_call_function(opd.lead_id)">Click to Call</span></td>
                        <td *ngIf="myrole=='1' || myrole=='4' || myrole=='21' || myrole=='11' || userId == '125' || userId == '431' || userId == '490'"><span class='p-2 badge btn-primary pointer-cur' (click)="call_details(opd.lead_id)">Call Details</span></td>
                        <td>{{opd.circle_name}}</td>
                        <td>{{opd.bd_name}}</td>
                        <td>{{opd.treatment_name}}</td>
                        <td>{{opd.machinename}}</td>
                        <td>
                            <span *ngIf="opd.appointment_type=='1'">New Scan</span>
                            <span *ngIf="opd.appointment_type=='2'">Re-Scan</span>
                            <span *ngIf="opd.appointment_type=='3'">Trust Align</span>
                        </td>
                        <td>{{opd.lead_date*1000|date:'d MMM, yyyy hh:mm aa'}}</td>
                        <td>{{opd.appointment_datetime*1000|date:'d MMM, yyyy'}}</td>
                        <td>{{opd.time_slots}}</td>
                        <td><span *ngIf="opd.payment_datetime">{{opd.payment_datetime*1000|date:'d MMM, yyyy hh:mm aa'}}</span></td>
                        <td>
                            <span *ngIf="opd.visit_type=='1'">Home</span>
                            <span *ngIf="opd.visit_type=='2'">Clinic</span>
                            <span *ngIf="opd.visit_type=='3'">Glamyo</span>
                        </td>
                        <td>
                            <span *ngIf="opd.visit_type=='2'">-</span>
                            <span *ngIf="opd.visit_type!='2'">{{opd.address}}</span>
                            
                        </td>
                        <td>{{opd.hospitalname}}</td>
                        <!-- <td>{{opd.payment_mode}}</td> -->
                        <td>{{opd.package_price}}</td>
                        <td>{{opd.totalAmt}}</td>
                        <td>{{opd.received_amt}}</td>
                        <td>{{calculate_gst(opd.totalAmt,opd.payment_datetime)}}</td>
                        <td>{{opd.totalAmt - calculate_gst(opd.totalAmt,opd.payment_datetime)}}</td>
                        <td><span *ngIf="opd.share_with_patient_on">{{opd.share_with_patient_on*1000|date:'d MMM, yyyy hh:mm aa'}}</span></td>
                        <td><span *ngIf="opd.approval_received==1">Yes</span><span *ngIf="opd.approval_received!=1">No</span></td>
                        <td><span *ngIf="opd.approval_received_date">{{opd.approval_received_date*1000|date:'d MMM, yyyy'}}</span></td>
                        <td>
                            <div *ngIf="opd.scan_status == 2">
                                <span *ngIf="opd.rca==1">Budget Problem</span>
                                <span *ngIf="opd.rca==2">Want Reschedule</span>
                                <span *ngIf="opd.rca==3">Cancel Appointment</span>
                                <span *ngIf="opd.rca==4">Scanner Movement Delay</span>
                                <span *ngIf="opd.rca==5">Not Answer</span>
                            </div>
                        </td>
                        <td>
                          <div *ngIf="opd.scan_status == 2">
                              <span *ngIf="opd.sub_rca==1">Other</span>
                              <span *ngIf="opd.sub_rca==2">Physically not well</span>
                              <span *ngIf="opd.sub_rca==3">Customer Not available</span>
                              <span *ngIf="opd.sub_rca==4">Scanner Issue</span>
                              <span *ngIf="opd.sub_rca==5">Customer Cancel</span>
                              <span *ngIf="opd.sub_rca==6">Customer Refused</span>
                              <span *ngIf="opd.sub_rca==7">Cancel by Counsellor</span>
                              <span *ngIf="opd.sub_rca==8">Cancel By Pro</span>
                              <span *ngIf="opd.sub_rca==9">Denied Pro</span>
                              <span *ngIf="opd.sub_rca==10">Travel Distance High</span>
                              <span *ngIf="opd.sub_rca==11">Office Boy Not Reached On Time</span>
                              <span *ngIf="opd.sub_rca==12">Last appointment Was Delay</span>
                              <span *ngIf="opd.sub_rca==13">Booked by Underage</span>
                              <span *ngIf="opd.sub_rca==14">Wrong Booking</span>
                              <span *ngIf="opd.sub_rca==15">Fake Booking</span>
                          </div>
                      </td>
                        <td>{{opd.campaign_name}}</td>
                        <td>{{opd.keywords}}</td>
                        <td>{{opd.utm_agid}}</td>
                        <td>{{opd.matchtype}}</td>
                        <td>{{opd.zoho_lead_source}}</td>
                        <td>{{opd.mdspok_user}}</td>
                        <td *ngIf="myrole=='1' || (myrole=='3' && userId == '411') || userId=='125' || userId == '431' || userId == '548'">{{opd.dental_spock_user}}</td>
                        <td *ngIf="myrole=='1' || (myrole=='3' && userId == '411') || userId=='125' || userId == '431' || userId == '548'">
                          <span *ngIf="opd.spok_status_id=='1'">Payment Received</span>
                          <span *ngIf="opd.spok_status_id=='2'">DNP</span>
                          <span *ngIf="opd.spok_status_id=='3'">Treatment Hold</span>
                          <span *ngIf="opd.spok_status_id=='4'">Forfeit</span>
                          <span *ngIf="opd.spok_status_id=='5'">Followup</span>
                          <span *ngIf="opd.spok_status_id=='6'">Plan Pending</span>
                          <span *ngIf="opd.spok_status_id=='7'">Documents Pending</span>
                        </td>
                        <td *ngIf="myrole=='1' || (myrole=='3' && userId == '411') || userId=='125' || userId == '431' || userId == '548'">
                          <span *ngIf="opd.spoc_sub_status_id=='8'">Part Payment Received</span>
                          <span *ngIf="opd.spoc_sub_status_id=='9'">Full Payment</span>
                          <span *ngIf="opd.spoc_sub_status_id=='10'">RNR</span>
                          <span *ngIf="opd.spoc_sub_status_id=='11'">Switched Off</span>
                          <span *ngIf="opd.spoc_sub_status_id=='12'">Not Contactable after many attempts</span>
                          <span *ngIf="opd.spoc_sub_status_id=='13'">Fund Issue</span>
                          <span *ngIf="opd.spoc_sub_status_id=='14'">Rescan</span>
                          <span *ngIf="opd.spoc_sub_status_id=='15'">Replan Pending</span>
                          <span *ngIf="opd.spoc_sub_status_id=='16'">Out of City</span>
                          <span *ngIf="opd.spoc_sub_status_id=='17'">Other (Treatment Hold)</span>
                          <span *ngIf="opd.spoc_sub_status_id=='18'">EMI Rejected Low Cibil</span>
                          <span *ngIf="opd.spoc_sub_status_id=='19'">Dont want extraction</span>
                          <span *ngIf="opd.spoc_sub_status_id=='20'">Delay in Follow Up</span>
                          <span *ngIf="opd.spoc_sub_status_id=='21'">Not Happy With Plan</span>
                          <span *ngIf="opd.spoc_sub_status_id=='22'">Wrong Information Shared by Pro</span>
                          <span *ngIf="opd.spoc_sub_status_id=='23'">Other (Forfeit)</span>
                          <span *ngIf="opd.spoc_sub_status_id=='24'">Rescan (Followup)</span>
                          <span *ngIf="opd.spoc_sub_status_id=='25'">Replan Required</span>
                          <span *ngIf="opd.spoc_sub_status_id=='26'">Part Payment Approval Pending</span>
                          <span *ngIf="opd.spoc_sub_status_id=='27'">Other (Followup)</span>
                          <span *ngIf="opd.spoc_sub_status_id=='28'">Lab Side Pending</span>
                          <span *ngIf="opd.spoc_sub_status_id=='29'">Rescan Files Pending</span>
                          <span *ngIf="opd.spoc_sub_status_id=='30'">Delay by Ops team</span>
                          <span *ngIf="opd.spoc_sub_status_id=='31'">Not shared by city team</span>
                          <span *ngIf="opd.spoc_sub_status_id=='32'">Incorrect Docs shared</span>
                          <span *ngIf="opd.spoc_sub_status_id=='33'">Complete Documents Pending</span>
                          <span *ngIf="opd.spoc_sub_status_id=='34'">Bank Statement Pending</span>
                          <span *ngIf="opd.spoc_sub_status_id=='35'">Co-Applicant Documents pending</span>
                          <span *ngIf="opd.spoc_sub_status_id=='36'">Documents Pending</span>
                          <span *ngIf="opd.spoc_sub_status_id=='37'">Payment link shared waiting for confirmation</span>
                          <span *ngIf="opd.spoc_sub_status_id=='38'">Clinic visit required</span>
                          <span *ngIf="opd.spoc_sub_status_id=='39'">Trust issue / Need a F2F visit</span>
                          <span *ngIf="opd.spoc_sub_status_id=='40'">Cash / cheque doorstep collection</span>
                        </td>
                        <td *ngIf="myrole=='1' || (myrole=='3' && userId == '411') || userId=='125' || userId == '431' || userId == '548' || myrole=='21'">
                          <span *ngIf="opd.spoc_followup_date">{{opd.spoc_followup_date*1000|date:'d MMM, yyyy hh:mm aa'}}</span>
                        </td>
                        <td *ngIf="myrole=='1' || (myrole=='3' && userId == '411') || userId=='125' || userId == '431' || userId == '548' ">
                          <div class="dropdown">
                             <button class="btn btn-secondary dropdown-toggle" type="button" id="{{opd.id}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                 Assign To Dental Spok
                             </button>
                             <div class="dropdown-menu">
                                 <a class="dropdown-item" *ngFor="let dental_Spoc_Role of dentalSpocRole;" (click)="updateAssigneDentalSpok(dental_Spoc_Role.id, opd.id)"><i class="fa fa-user"></i> {{dental_Spoc_Role.name}} </a>
                             </div>
                          </div>
                        </td>
                        <td *ngIf="myrole!='15' && myrole!='6' &&  myrole!='19' && myrole!='7'">
                             <div class="dropdown">
                                <button class="btn btn-secondary dropdown-toggle" type="button" id="{{opd.id}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Action
                                </button>
                                <div class="dropdown-menu" aria-labelledby="{{opd.id}}">
                                    <a *ngIf="myrole!='8' && myrole!='24'" class="dropdown-item" (click)="sharePaymentLink(opd.lead_id,opd.id,5)"><i class="fa fa-credit-card"></i>Share Payment Link</a>
                                    <a class="dropdown-item" (click)="openScanPage(opd,1)"> 
                                      <span *ngIf="myrole!='8' && myrole!='24'"><i class="fa fa-pen"></i> Update Scan</span>
                                      <span *ngIf="myrole=='8' || myrole=='24'"><i class="fa fa-eye"></i> View Scan</span>
                                    </a>
                                    <a class="dropdown-item" *ngIf="myrole!='21' && myrole!='8' && myrole!='24'" (click)="updateScanStatus(opd.id,1)"><i class="fa fa-check"></i> Completed Scan</a>
                                    <a class="dropdown-item" *ngIf="myrole!='21' && myrole!='8' && myrole!='24'" (click)="updateScanStatus(opd.id,3)"><i class="fa fa-check"></i> Cancelled Scan</a>
                                    <a *ngIf="opd.status!=0 && opd.cnt==0 && myrole!='21' && myrole!='8' && myrole!='24'" class="dropdown-item" (click)="openScanPage(opd,2)"><i class="fa fa-pen"></i> Re-Scan</a>
                                    <a *ngIf="myrole=='1' || myrole=='21' || userId=='125' || userId == '431'" class="dropdown-item" (click)="spokRemarks(opd.id)"><i class="fa fa-pen"></i> Spok Remarks</a>
                                    <a *ngIf="(myrole=='1' || myrole=='9' || (myrole=='3' && isCMAccess == 1)) && opd.payment_status=='1'" class="dropdown-item" (click)="accountsRemarks(opd.id, opd.lead_id)"><i class="fa fa-pen"></i> Accounts Remarks</a>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr *ngIf="loading">
                        <td colspan="22" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                    </tr>
                    <tr *ngIf="loaded && !scanList.length">
                        <td colspan="22" ><i class="far fa-frown"></i> Record not found</td>
                    </tr>
                </tbody>
            </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>
    </div>
</div>
<!-----------------For Click to Call-------------------------->
<div class="modal fade" id="click_to_call_progress" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title" style="font-weight: bold;">Call Progression</h4>
        </div>
        <!-- Modal body -->
          <div class="modal-body">
                <div class="alert alert-danger" *ngIf="progression_msg">
                  <strong>Warning!</strong> {{progression_msg}}
                </div>
                <div class="form-group">
                  <div class="row">
                    <div style="font-size: 18px;" class="col-sm-12 modal-title text-center" id="click_to_call_progress_html">
                      <i class="fa fa-cog fa-spin"></i><br />
                      <h2>Call is under progress.</h2>
                    
                    </div>
                  </div>
                </div>
          </div>
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" [disabled]="end_to_call_btn_disable" class="btn btn-success" (click)="endClicktoCall()">Close</button>
        </div>
      </div>
    </div>
</div>

<!-----------------Scan-book-call-Details-------------------------->
<div class="modal fade" id="scan_book_call_details" data-keyboard="false" data-backdrop="static" style="margin-top:80px ;">
    <div class="modal-dialog modal-lg modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" style="font-weight: bold;">Call Details</h4>
        </div> 
          <div class="modal-body">
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm-12 modal-title text-center">
                        <div style="overflow-x:auto;">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">Name</th>
                            <th scope="col">Duration <small>(In Minutes)</small></th>
                            <th scope="col">Time</th>
                            <th colspan="2">Call Recording Link</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let callData of callDetails;let index = index;">
                            <th scope="row">{{index+1}}</th>
                            <td>{{callData.call_by_name}}</td>
                            <td>{{(callData.call_duration/60)|number : '.2-2'}}</td>
                            <td> {{callData.created_at*1000|date:'d MMM, yyyy H:mm aa'}}</td>
                            <td [innerHTML]="callData.click_to_call_recording_links"></td>
                            <td>
                            <button title="copy" class="pointer-cur" (click)="copyMessage('http://'+callData.click_to_call_link_only)"><i class="fa fa-copy"></i></button>
                            </td>
                          </tr>
                          <tr *ngIf="loaded && !callDetails.length">
                            <td colspan="5"><i class="far fa-frown"></i> Data not found</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
          <button type="button"  class="btn btn-success" id="scan_book_call_details" (click)="closeCallDetailsModal()">Close</button>
        </div>
      </div>
    </div>
</div>


<!-- The Modal For Assigned to Dental Spok -->
<div class="modal fade" id="scanbookAssignedToDentalSpok">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Import Spoc of Scanbook </h4>
        <button type="button" class="close" (click)="hideAssignedToDentalModal()"></button>
      </div>

      <!-- Modal body -->
        <div class="modal-body">
            <div class="form-group">
                <div class="row">
                    <label class="col-sm-12">Upload CSV</label>
                    <input [disabled]="submitted" type="file" #csvScanbookBulkAssignedToSpok (change)="selectFileUpdateLeadStatus($event)" class="form-control" />
                </div>
                <span *ngIf="submitted"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
            </div>
            <div class="form-group" *ngIf="updatedLeadsStatus || notUpdatedLeadsStatus">
              <div class="row">
                <div class="col-sm-12">
                    <h5><span style="word-wrap: break-word;"><b>Updated LeadIds : </b>{{updatedLeadsStatus}}</span></h5>
                    <h5><span style="word-wrap: break-word;"><b>Not Updated LeadIds : </b>{{notUpdatedLeadsStatus}}</span></h5>
                </div>
            </div>
            </div>
        </div>

      <!-- Modal footer -->
      <div class="modal-footer">
        <button type="button" class="btn" (click)="hideAssignedToDentalModal()">Close</button>
      </div>
    </div>
  </div>
</div>

